var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1915 24.5445H21.1202C11.1502 24.5445 3.06677 32.6279 3.06677 42.5979C3.06677 52.5679 11.1502 60.6514 21.1202 60.6514H45.1915C55.1615 60.6514 63.2449 52.5679 63.2449 42.5979C63.2449 32.6279 55.1615 24.5445 45.1915 24.5445Z",
    stroke: "black",
    strokeWidth: 6.01781,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1202 36.5801V48.6158M15.1024 42.598H27.138M33.1558 21.5356V12.0786H45.1914V3.48218",
    stroke: "black",
    strokeWidth: 6.01781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1915 48.6157C46.7875 48.6157 48.3181 47.9817 49.4467 46.8531C50.5752 45.7246 51.2093 44.1939 51.2093 42.5979C51.2093 41.0019 50.5752 39.4712 49.4467 38.3427C48.3181 37.2141 46.7875 36.5801 45.1915 36.5801C43.5954 36.5801 42.0648 37.2141 40.9362 38.3427C39.8077 39.4712 39.1736 41.0019 39.1736 42.5979C39.1736 44.1939 39.8077 45.7246 40.9362 46.8531C42.0648 47.9817 43.5954 48.6157 45.1915 48.6157Z",
    stroke: "black",
    strokeWidth: 6.01781,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.eaf26d18f5703f5b5f7eeb40fba11ed4.svg";
export { ForwardRef as ReactComponent };